import cx from "classnames";
import { IconDefinition } from "@fortawesome/pro-regular-svg-icons";

import Icon from "common/components/Icon";

import styles from "../../styles/Status.module.less";

export type StatusColor = "greyscale" | "primary" | "success" | "danger" | "warning";

type StatusProps = {
  color?: StatusColor;
  children: React.ReactNode;
};

const Status = ({ color = "greyscale", children }: StatusProps) => {
  return <span className={cx(styles.container, styles[color])}>{children}</span>;
};

type StatusIconProps = {
  color?: StatusColor;
  icon: IconDefinition;
};

const StatusIcon = ({ color = "greyscale", icon }: StatusIconProps) => {
  return (
    <span className={cx(styles.iconContainer, styles[color])}>
      <svg className={styles.hex} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 31">
        <path
          stroke="none"
          fill="currentColor"
          d="M12.5 1.2320508075689a6 6 0 0 1 6 0l7.856406460551 4.5358983848622a6 6 0 0 1 3 5.1961524227066l0 9.0717967697245a6 6 0 0 1 -3 5.1961524227066l-7.856406460551 4.5358983848622a6 6 0 0 1 -6 0l-7.856406460551 -4.5358983848623a6 6 0 0 1 -3 -5.1961524227066l0 -9.0717967697245a6 6 0 0 1 3 -5.1961524227066"
        />
      </svg>
      <Icon className={styles.icon} icon={icon} />
    </span>
  );
};

export default Object.assign(Status, { Icon: StatusIcon });
